import { adminApi } from "../store/api/adminApi";
import { runMutation, runQuery, runQueryNoArg } from "../store/api/runtime";
import type { BlogCategory, BlogPost, BlogPostPayload } from "../types/blogs";

export async function getAdminReports(): Promise<unknown[]> {
  return runQueryNoArg(adminApi.endpoints.getAdminReports.initiate);
}

export async function reviewAdminReport(
  reportId: string,
  payload: { action?: string; resolution?: string; notes?: string },
): Promise<unknown> {
  return runMutation(adminApi.endpoints.reviewAdminReport.initiate, { reportId, payload });
}

export async function getAdminVerifications(): Promise<unknown[]> {
  return runQueryNoArg(adminApi.endpoints.getAdminVerifications.initiate);
}

export async function getAdminLogs(
  params?: { action?: string; adminId?: string; targetUserId?: string },
): Promise<unknown[]> {
  return params
    ? runQuery(adminApi.endpoints.getAdminLogs.initiate, params)
    : runQueryNoArg(adminApi.endpoints.getAdminLogs.initiate);
}

export async function getAdminWaitlist(
  params?: { query?: string; favoriteGameOption?: string },
): Promise<{ totalCount: number; items: unknown[] }> {
  return params
    ? runQuery(adminApi.endpoints.getAdminWaitlist.initiate, params)
    : runQueryNoArg(adminApi.endpoints.getAdminWaitlist.initiate);
}

export async function reviewAdminVerification(
  verificationId: string,
  payload: { decision: "approve" | "reject"; rejectionReason?: string | null },
): Promise<unknown> {
  return runMutation(adminApi.endpoints.reviewAdminVerification.initiate, { verificationId, payload });
}

export async function getAdminBlogPosts(): Promise<BlogPost[]> {
  return runQueryNoArg(adminApi.endpoints.getAdminBlogs.initiate);
}

export async function getAdminBlogCategories(): Promise<BlogCategory[]> {
  return runQueryNoArg(adminApi.endpoints.getAdminBlogCategories.initiate);
}

export async function createAdminBlogCategory(payload: { name: string }): Promise<BlogCategory> {
  return runMutation(adminApi.endpoints.createAdminBlogCategory.initiate, payload);
}

export async function createAdminBlogPost(payload: BlogPostPayload): Promise<BlogPost> {
  return runMutation(adminApi.endpoints.createAdminBlog.initiate, payload);
}

export async function updateAdminBlogPost(postId: string, payload: BlogPostPayload): Promise<BlogPost> {
  return runMutation(adminApi.endpoints.updateAdminBlog.initiate, { postId, payload });
}

export async function deleteAdminBlogPost(postId: string): Promise<{ success: boolean }> {
  return runMutation(adminApi.endpoints.deleteAdminBlog.initiate, { postId });
}
